import { useCallback } from 'react'
import { useAttachmentUpload } from '../../../hooks/useAttachmentUpload'
import { systemIssuesService } from '../../../services/systemIssuesService'

/**
 * Wrapper fino sobre o hook genérico de upload — igual ao de Ocorrências,
 * mas o endpoint de prepare aqui não recebe `issueId` (o anexo pode ser
 * enviado antes da issue existir, no formulário de "novo problema"; ver
 * `system-issues/pending/{uuid}` no backend). Sempre habilitado — qualquer
 * usuário interno pode anexar, sem depender de nenhum recurso já existir.
 */
export function useSystemIssueAttachmentUpload() {
  const prepareUploads = useCallback(
    (files: Array<{ originalName: string; contentType: string; size: number }>) =>
      systemIssuesService.prepareAttachmentUploads(files),
    [],
  )

  return useAttachmentUpload({
    enabled: true,
    prepareUploads,
    isFileAllowed: (file) =>
      file.type.startsWith('image/')
        ? true
        : `${file.name}: só é possível anexar imagens (PNG, JPG, GIF, WEBP etc.)`,
  })
}
